module.exports = __webpack_public_path__ + "img/miaochangjing.78c6c208.png";